import React, { useEffect } from "react";
import { ReactComponent as AddUserIcon } from "../../../assets/icons/management/adduser.svg";
import { IPhoneOrder } from "../../../types/phoneOrder.type";
import { IProduct } from "../../../types/product.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import AddPhoneOrderBoxingForm from "../forms/AddPhoneOrderBoxingForm/AddPhoneOrderBoxingForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  order: IPhoneOrder;
  products: IProduct[];
}

const AddPhoneOrderBoxingModal: React.FC<Props> = (props) => {
  const onApply = () => {
    props.onApply();
    props.onClose();
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [props.onClose]);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          onClose={props.onClose}
          title="Add withdraw"
          subTitle="Add batcher's products to withdraw"
          isLittleMargin={true}
        >
          <AddUserIcon />
        </ModalTitle>
        <AddPhoneOrderBoxingForm
          onApply={onApply}
          order={props.order}
          onClose={props.onClose}
          products={props.products}
        />
      </div>
    </DefaultModal>
  );
};

export default AddPhoneOrderBoxingModal;
